import React from "react";
import { PlanrButton, Stack } from "modules/common/components/ui";
import { useInstall } from "../../../../mobile/services/install";
import { browserEnv, isPhone } from "../../../../mobile/services/version-core";
import styles from "./InstallOffer.module.scss";

/**
 * Предложение установить Rost как приложение на компьютере: небольшая панель в углу экрана
 * (R13, FR-020, FR-022, US5-1). Показывается вошедшему пользователю на компьютере, пока
 * приложение не установлено, браузер позволяет установку и «Позже» не нажато в последние 14 дней.
 * На телефоне полная версия предложения не показывает: там установка — в мобильной версии.
 */
export const InstallOffer = () => {
    const { offerVisible, platform, prompt, snooze } = useInstall();

    if (!offerVisible || platform !== "desktop" || isPhone(browserEnv())) {
        return null;
    }

    return (
        <div className={styles.offer} role="region" aria-label="Установка приложения">
            <div className={styles.text}>Установите Rost как приложение</div>
            <Stack gap="s" justify="flex-end">
                <PlanrButton type="graybtn" size="small" onClick={snooze}>
                    Позже
                </PlanrButton>
                <PlanrButton type="primary" size="small" onClick={() => void prompt()}>
                    Установить
                </PlanrButton>
            </Stack>
        </div>
    );
};
